<template>
  <div class="transfer">
    <div>
<!--      <div class="tips-burden">Do not make repeated payments to the sameaccount</div>-->
      <div class="tips">Make a single transfer from your bank to</div>

      <div class="bank-info">
        <div class="info-row line">
          <div class="label">Account Number</div>
          <div class="value"
               v-clipboard:copy="accountNumber"
               v-clipboard:success="firstCopySuccess"
               v-clipboard:error="firstCopyError"
          >{{ UserInfo.accountNumber || 0 }}
            <img src="../../../assets/images/copy@3x.png"/></div>
        </div>

        <div class="info-row line">
          <div class="label">Bank Name</div>
          <div class="value"
               v-clipboard:copy="transferBankName"
               v-clipboard:success="firstCopySuccess"
               v-clipboard:error="firstCopyError"
          >{{ UserInfo.transferBankName || 0 }}
            <img src="../../../assets/images/copy@3x.png"/></div>
        </div>

        <div class="info-row">
          <div class="label">Account Name</div>
          <div class="value">{{ UserInfo.accountName || 0 }}</div>
        </div>
      </div>

      <!--      -->
      <div class="remarks">
        <div class="tipsred">
          This account is valid for one time Please do not transfer multiple times
        </div>
      </div>

      <!--      -->
      <div class="payment" @click="payment">I Have Paid , Check now <img src="../../../assets/images/submit.png"/></div>


      <!--      <div class="copy_number">-->
      <!--        <div class="number" v-clipboard:copy="value" v-clipboard:success="firstCopySuccess"-->
      <!--             v-clipboard:error="firstCopyError">{{UserInfo.accountNumber}}-->

      <!--        </div>-->
      <!--        <div class="bank">{{UserInfo.transferBankName}}</div>-->
      <!--        <div class="remarks1">Above beneficiary account will expire after <span>{{count}} </span></div>-->
      <!--      </div>-->
      <!--      <div class="remarks">You will get a confirmation once we receive your payment</div>-->
      <!--      <div class="payment" @click="payment">I Have Paid , Check now</div>-->
    </div>
    <!--    <div class="loading">-->
    <!--      <van-loading color="#1989fa" size="60px" v-show="flag"/>-->
    <!--    </div>-->


  </div>
</template>
<script>
import {encryption} from "../../../utils/requestUtils";

export default {
  data() {
    return {
      accountNumber: '',
      transferBankName: '',
      flag: false,
      code: Number,
      status: false,
      request_flag: true,
      List: {},
      count: '', //倒计时
      seconds: 0 // 10天的秒数

    }
  },
  mounted() {
    this.getParams()

    // this.getInfo()
    this.accountNumber = this.UserInfo.accountNumber || '0'
    this.transferBankName = this.UserInfo.transferBankName || '0'
  },
  props: ['Params', 'UserInfo'],
  watch: {
    UserInfo(val) {
      this.accountNumber = this.UserInfo.accountNumber
      this.transferBankName = this.UserInfo.transferBankName
      this.Time(this.UserInfo.timeoutSeconds) //调用定时器
    }
  },
  methods: {
    // 点击I've made this payment
    /**
     * 订单状态 0 待支付 1 已支付 2 已失效
     private Integer status;
     *
     */
    payment() {
      if (!this.request_flag) {
        return
      }
      this.request_flag = false
      this.flag = true // 加载中...
      const sign = localStorage.getItem('sign')
      const timestamp = new Date().getTime()
      const curURL = `/api/order/status?merchantId=${this.List.merchantId}&merchantOrderId=${this.List.merchantOrderId}&amount=${this.Params.amount}&timestamp=${timestamp}&sign=${sign}`
      this.axios.post('/api/order/paymentStatus', {
        requestParam: encryption({
          merchantId: this.List.merchantId,
          merchantOrderId: this.List.merchantOrderId
        })
      }).then(res => {
        if (res.data.data.status == 0) {
          // 待支付
          this.flag = false
          this.$toast('Your money will be comfirmed in few minutes')
        } else if (res.data.data.status == 1) {
          // this.$toast('Payment success')
          // this.$router.push({path: '/success', query: {'image': this.UserInfo.logoUrl}})
          window.location.reload();
        } else if (res.data.data.status == 2) {
          // this.$toast('Failure to pay')
          // this.$router.push({path: '/timeout', query: {'image': this.UserInfo.logoUrl}})
          window.location.reload();
        }
        this.request_flag = true
      })
    },
    firstCopySuccess(e) {
      this.$toast("Account copied successfully!")
    },
    firstCopyError(e) {
      this.$toast("Fail!")
    },
    getTimes(t) {
      let h = parseInt(t / 60 / 60 % 24)
      let m = parseInt(t / 60 % 60)
      let s = parseInt(t % 60)
      //三元表达式 补零 如果小于10 则在前边进行补零 如果大于10 则不需要补零
      h = h < 10 ? '0' + h : h
      m = m < 10 ? '0' + m : m
      s = s < 10 ? '0' + s : s
      return `${m}:${s}`
    },
    Time(t) {
      let second = t
      const timeDetail = setInterval(() => {
        second -= 1
        if (second <= 0) {
          clearInterval(timeDetail)
          this.$toast('Order has expired！')
        }
      }, 1000)
    },

    getParams() {
      this.List = this.$route.query
    }
  }
}
</script>

<style scoped lang="scss">

.remarks {
  display: flex;
  align-items: start;

  font-size: 0.24rem;
  text-align: start;

  .text {
    margin-left: 0.08rem;
  }

  img {
    width: 0.26rem;
    height: 0.26rem
  }
}

.bank-info {
  padding: 0.4rem 0.28rem;
  background: #FFFFFF;
  margin-top: 0.50rem;
  border-radius: 0.2rem;
  display: flex;
  flex-direction: column;

  .info-row {
    display: flex;
    //margin: 0.26rem 0;
    padding: 0.28rem 0;
    justify-content: space-between;
    align-items: center;

    .label {
      font-size: 0.26rem;
      text-align: left;
    }

    .value {
      font-size: 0.28rem;
      font-weight: bold;
      color: #283B51;
      text-align: right;
    }

  }


}

.transfer {
  padding: 0.35rem 0;

  .van-loading {
    margin-top: 50%;
  }

  .tipsred {
    font-size: 0.24rem;
    color: red;
    font-weight: 600;
  }

  .tips-burden {
    font-size: 0.23rem;
    font-weight: bold;
    color: #3585FD;
    text-align: start;
    margin-bottom: 0.26rem;
  }

  .tips {
    font-size: 0.23rem;
    color: #283B51;
    font-weight: 600;
    text-align: start;

    div {
      margin-top: 0.2rem;
    }
  }

  .copy_number {
    height: 3.5rem;
    background-color: rgba(242, 240, 252, .53);
    border-radius: 0.2rem;

    .number {
      padding-top: 0.4rem;
      color: #7535FD;
      font-size: 0.48rem;
      font-weight: bold;
      line-height: 0.8rem;

      img {
        width: 0.3rem;
        margin-left: 0.1rem;
      }
    }

    .bank {
      color: #727272;
      font-size: 0.32rem;
      line-height: 0.6rem;
    }

    .remarks1 {
      color: #727272;
      padding-top: 0.5rem;
      font-size: 0.28rem;

      span {
        font-weight: bold;
      }
    }
  }

  .remarks {
    padding-top: 0.4rem;
    font-size: 0.28rem;
  }

  .payment {
    background: #283B51;
    border-radius: 0.1rem;
    height: 0.9rem;
    line-height: 0.9rem;
    color: #FFFFFF;
    font-weight: 100;
    font-size: 0.3rem;
    margin-top: 0.68rem;

    img {
      margin-left: 0.07rem;
      vertical-align: middle;
    }
  }
}

.loading {
  position: absolute;
  top: 30%;
  left: 50%;
  margin-left: -30px;
  z-index: 999;
}

.line {
  border-bottom: 1px solid rgba(45, 72, 117, 0.08);
}

</style>



// WEBPACK FOOTER //
// src/pages/ngn/components/transfer.vue